







//基础组件的自动化全局注册
//批量引入icons
//可通过此模板将文件夹中任意后缀的文件批量引用
let importAll = (requireContext:__WebpackModuleApi.RequireContext) => requireContext.keys().forEach(requireContext);
importAll(require.context('../assets/icons',true,/\.svg$/));

export default {
    name:'Icon',
    props:['name']
};
